import React, { useState } from "react"
import type { FocusPositionProps, PlayerPickProps } from "../../types"
import { CompetitionHelpers } from "../api"
import moment from "moment-mini"
import { Button, Text, TextInput, View } from "../../Components/Themed"
import { useColors } from "../../constants/useColors"


type WagerPickFormProps = {
    event_title:string,
    balance:number,
    event_start:string,
    player_pick: PlayerPickProps,
    loading?:string,
    mode:'desktop'|'mobile',
    padding_bottom?:number,
    onFocusPosition?:(pos:FocusPositionProps) => void,
    width:number,
    onCancel: () => void,
    onSubmit: (pp:PlayerPickProps) => void
}

const WagerPickForm = ({ player_pick, mode, event_title, balance, event_start, padding_bottom, loading, onCancel, onFocusPosition, onSubmit }:WagerPickFormProps) => {
    const C = useColors();
    const [ reviewed, setReviewed ] = useState(false);
    const [ wager, setWager ] = useState({ stake:0, stake_label: '', potential_winnings: 0 });


    const handleWagerChange = (text:string) => {
        if(text == ''){ return setWager({ stake:0, stake_label:'', potential_winnings:0 }) }
        let wager_amt = parseFloat(text)
        let potential_winnings = CompetitionHelpers.calcPotentialWinnings(wager_amt, player_pick.odds)
        setWager({ stake:wager_amt, stake_label:wager_amt.toString(), potential_winnings })
    }

    const handleSubmit = () => {
        if(wager.stake > balance){ return alert('Not enough balance to make pick') }
        if(!reviewed){ return setReviewed(true) }
        if(wager.stake <= 0){ return alert('Invalid wager amount') }
        if(wager.potential_winnings <= 0){ return alert('Invalid Wager') }
        onSubmit({ ...player_pick, stake: wager.stake, potential_winnings: wager.potential_winnings })
    }

    return (
        <View float style={mode=='desktop' ?{borderRadius:22, width:500}:{ borderTopRightRadius:22, borderTopLeftRadius:22, paddingBottom:padding_bottom }}>
            <View transparent nativeID="event_info" style={{ padding:20 }}>
                <Text size={14} theme="h2" weight='bold' textAlign="center">{moment(event_start).format('MM/DD @ hh:mm a')}</Text>
                <Text style={{ marginTop:5 }} size={14} theme="h2" weight='bold' textAlign="center">{event_title}</Text>
            </View>
            <View transparent nativeID="pick_details" style={{ padding:10 }}>
                <View transparent nativeID="outcome" style={{ flexDirection:'row', margin:5 }}>
                    <Text style={{ flex:1 }} size={14} theme="description" weight='regular'>Outcome</Text>
                    <Text style={{ flex:2 }} size={14} theme='h2' weight="semibold" textAlign="right">{player_pick.pick_title}</Text>
                </View>
                <View transparent nativeID="probability" style={{ flexDirection:'row', margin:5 }}>
                    <Text style={{ flex:1 }} size={14} theme="description" weight='regular'>Probability</Text>
                    <Text style={{ flex:2 }} size={14} theme="h2" weight="semibold" textAlign="right">{(player_pick.probability * 100).toFixed(2)}%</Text>
                </View>
                <View transparent nativeID="odds" style={{ flexDirection:'row', margin:5 }}>
                    <Text style={{ flex:1 }} size={14} theme="description" weight='regular'>Odds</Text>
                    <Text style={{ flex:2 }} size={14} theme="h2" weight="semibold" textAlign="right">{CompetitionHelpers.getOddsLabel(player_pick.odds)}</Text>
                </View>
            </View>
            <View transparent type='row' nativeID="pick_input" style={{ padding:10, alignItems:'flex-start' }}>
                <View transparent style={{ flexGrow:1, marginRight:10 }}>
                    <Text size={14} theme="description">WAGER AMOUNT</Text>
                    <View transparent type='input' style={{ flexDirection:'row', alignItems:'center', marginTop:5 }}>
                        <Text size={14} textAlign="center" theme="h2" style={{ padding: 10}}>E</Text>
                        <TextInput
                            style={{ textAlign:'center', flex:1 }}
                            onFocusPosition={onFocusPosition}
                            value={wager.stake_label}
                            onChangeText={(text) => handleWagerChange(text)}
                        />
                    </View>
                    <Text weight='semibold' style={{ margin:5 }} color={C.text.success}>{balance.toFixed(2)} Available</Text>
                </View>
                <View transparent style={{ flexGrow:0.5, marginLeft:10 }}>
                    <Text size={14} theme="description">WINNINGS</Text>
                    <View type='input' style={{ flexDirection:'row', marginTop:5 }}>
                    <Text size={14} textAlign="center" theme="h2" style={{ padding: 10}}>E</Text>
                        <Text
                            style={{ padding:15 }}
                            textAlign="center"
                            size={14} color={C.text.h1}
                        >
                            {wager.potential_winnings.toFixed(2)}
                        </Text>
                    </View>
                </View>
            </View>
            <View transparent nativeID="pick_actions" style={{ flexDirection:'row', padding:10 }}>
                <Button
                    style={{ flex:1, marginRight:3 }}
                    type='close'
                    title="Cancel"
                    onPress={() => onCancel()}
                />
                 <Button
                    style={{ flex:2, marginLeft:2, opacity:loading || wager.stake <= 0 || wager.stake > balance ? 0.5 : 1 }}
                    disabled={ loading || wager.stake <= 0 || wager.stake > balance ? true : false }
                    type='success'
                    title={reviewed ? 'Submit' : 'Review'}
                    onPress={() => handleSubmit()}
                />
            </View>
        </View>
    )
}

export default WagerPickForm